import React, { useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { SnackbarOptions } from './types';
import { SnackbarContext } from './snackbar-context';
import { useBoolean } from 'src/hooks/use-boolean';

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { value: isOpen, onTrue: openSnackbar, onFalse: closeSnackbar } = useBoolean(false);
  const [snackbarOptions, setSnackbarOptions] = useState<SnackbarOptions>({
    message: '',
    severity: 'error',
    duration: 3000,
  });

  const showSnackbar = (options: SnackbarOptions) => {
    setSnackbarOptions({
      message: options.message,
      severity: options.severity || 'error',
      duration: options.duration || 3000,
      variant: 'filled',
      action: options.action,
    });
    openSnackbar();
  };

  const { action } = snackbarOptions;

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={isOpen}
        autoHideDuration={snackbarOptions.duration}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbarOptions.severity}
          sx={{ width: '100%' }}
          data-testid="snackbar"
          data-severity={snackbarOptions.severity}
          action={
            action && (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  action.onClick();
                  closeSnackbar();
                }}
              >
                {action.label}
              </Button>
            )
          }
        >
          {snackbarOptions.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
